/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodProfileEquivalenceFormEquivalentCommodity: "good-profile-equivalence-form-equivalent-commodity",
  goodProfileEquivalenceFormEquivalentCommodityPlaceholder: "good-profile-equivalence-form-equivalent-commodity-placeholder",
  goodProfileEquivalenceFormCommodityOption: "good-profile-equivalence-form-commodity-option",
  goodProfileEquivalenceFormAddCondition: "good-profile-equivalence-form-add-condition",
  goodProfileEquivalenceFormRemoveCondition: "good-profile-equivalence-form-remove-condition",
} as const;
